// after selected items changing,
// update recommended markup price for each selected item
export function updateSelectedItemsRecommendMarkup(orderTestSupportObj) {
    let { selectedItemList, testNodeList, bundleList } = orderTestSupportObj;
    let testList = testNodeList.map(n => n.value);
    // exclude items with markup price & markup price version > -1
    // i.e. those with markup price set up by user directly
    selectedItemList.forEach(item => {
      if (item.markupVersion > -1) {
        return;
      }
      let markup = { markupPrice: 0, markupVersion: null };
      switch (item.category) {
        case "discountPanel": 
        case "xChooseY":
          markup = getPanelMarkup(item, testList);
          break;
        case "customPanel":
          markup = getCustomPanelMarkup(item, bundleList, testList);
          break;
        case "shortcut": {
          markup = getShortcutMarkup(item, bundleList, testList);
          break;
        }
        default:
          break;
      }
      let { markupPrice, markupVersion } = markup;
      if (markupVersion) {
        item.markupPrice = Number(markupPrice.toFixed(2));
        item.markupVersion = markupVersion;
      }
    });
  }
  
// get recommended markup price for shortcut if it didn't set up any
function getShortcutMarkup(shortcut, bundleList, testList) {
if (shortcut.markupPrice && shortcut.markupVersion > -1) {
    return { 
    markupPrice: shortcut.markupPrice, 
    markupVersion: shortcut.markupVersion
    };
}
let shortcutMarkupPrice = 0;
let shortcutMarkupVersion = null;
let { customPanelIdList, discountPanelIdList, xChooseYIdList, testIdList } = shortcut;
let xChooseYPanelIds = xChooseYIdList.map(item => item.bundleId);
let panelIds = customPanelIdList.concat(discountPanelIdList).concat(xChooseYPanelIds);
let panels = bundleList.filter(b => panelIds.includes(b.bundleId));
panels.forEach(p => {
    let panelMarkup = p.category === "customPanel" 
    ? getCustomPanelMarkup(p, bundleList, testList)
    : getPanelMarkup(p, testList);
    if (panelMarkup.markupVersion) {
    shortcutMarkupVersion = -1;
    }
    shortcutMarkupPrice += panelMarkup.markupPrice;
});
let testsMarkup = getTestListMarkup(testIdList, testList);
if (testsMarkup.markupVersion) {
shortcutMarkupVersion = -1;
}
shortcutMarkupPrice += testsMarkup.markupPrice;
return { 
markupPrice: shortcutMarkupPrice,
markupVersion: shortcutMarkupVersion
};
}

// get recommended markup price for custom panel is it doesn't set up any
function getCustomPanelMarkup(panel, bundleList, testList) {
    if (panel.markupPrice && panel.markupVersion > -1) {
    return { 
    markupPrice: panel.markupPrice, 
    markupVersion: panel.markupVersion
    };
}
let { bundleItemList } = panel;
let bundleIds = bundleItemList.filter(content => content.itemType === "official bundle").map(c => c.itemId);
let testIds = bundleItemList.filter(content => content.itemType !== "official bundle").map(c => c.itemId);
let bundles = bundleList.filter(b => bundleIds.includes(b.bundleId));
let customPanelMarkupPrice = 0;
let customPanelMarkupVersion = null;
bundles.forEach(b => {
    let { markupPrice, markupVersion } = getPanelMarkup(b, testList);
    if (markupVersion) {
    customPanelMarkupVersion = -1;
    }
    customPanelMarkupPrice += markupPrice;
});
let testListMarkup = getTestListMarkup(testIds, testList);
if (testListMarkup.markupVersion) {
    customPanelMarkupVersion = -1;
}
customPanelMarkupPrice += testListMarkup.markupPrice;
return { 
    markupPrice: customPanelMarkupPrice,
    markupVersion: customPanelMarkupVersion
};
}

// get recommended markup price for discount panels and xChooseY panels
// if didn't setup any
function getPanelMarkup(panel, testList) {
if (panel.markupPrice && panel.markupVersion > -1) {
    return { 
    markupPrice: panel.markupPrice, 
    markupVersion: panel.markupVersion
    };
}
let testIds = [];
if (panel.category === "discountPanel") {
    testIds = panel.testIdsInPanel;
}
if (panel.category === "xChooseY") {
    let { selectedZoomerIdList, selectedSupplementIdList } = panel;
    testIds = (selectedZoomerIdList ? selectedZoomerIdList : [])
    .concat((selectedSupplementIdList ? selectedSupplementIdList : []));
}
let { markupPrice, markupVersion } = getTestListMarkup(testIds, testList);
return { markupPrice, markupVersion };
}

// get recommended markup price for a list of tests
function getTestListMarkup(testIds, testList) {
let markupPrice = 0;
let markupVersion = null;
let tests = testList.filter(t => testIds.includes(t.id)); 
if (tests.some(test => test.markupPrice)) {
    markupPrice = tests.reduce((acc, t) => {
    return acc + (t.markupPrice ? t.markupPrice : 0);
    }, 0);
    markupVersion = -1;
}
return { markupPrice, markupVersion };
}